import { useTranslation } from "react-i18next";

import { ACSES_COMMUNICATION_EVENT_TYPES, COMMUNICATION_CHANNELS } from "models";
import {
  useCustomerCommunicationTypes,
  useKeylockerCommunicationTypes
} from "modules/CommunicationTemplates/components/CommunicationTemplatesTable/hooks/useEventMessages";

import type { COMMUNICATION_EVENTS, KEYLOCKER_COMMUNICATION_EVENT_TYPE } from "models";

type GetCommunicationType = {
  event_type: COMMUNICATION_EVENTS | null;
  keylocker_communication_event_type: KEYLOCKER_COMMUNICATION_EVENT_TYPE | null;
  acses_communication_event_type: ACSES_COMMUNICATION_EVENT_TYPES | null;
};

export const useCommunicationTemplatesTableHandlers = () => {
  const { t } = useTranslation();

  const communicationEventsMessages = useCustomerCommunicationTypes();
  const keylockerCommunicationEventMessages = useKeylockerCommunicationTypes();

  const getCommunicationChannel = (channel: COMMUNICATION_CHANNELS) => {
    if (channel === COMMUNICATION_CHANNELS.SMS) return t("v8_sms", "SMS");
    if (channel === COMMUNICATION_CHANNELS.Email) return t("v8_email", "Email");
    return "";
  };

  const getCommunicationType = ({ acses_communication_event_type, event_type, keylocker_communication_event_type }: GetCommunicationType) => {
    if (event_type) return communicationEventsMessages[event_type];
    if (keylocker_communication_event_type) return keylockerCommunicationEventMessages[keylocker_communication_event_type];

    if (acses_communication_event_type === ACSES_COMMUNICATION_EVENT_TYPES.DropBackPinSent) return t("v8_acses_keylocker_key_dropped_back", "Acses key dropped back");

    return "";
  };

  return { getCommunicationType, getCommunicationChannel };
};
